import type { Messages } from '../en'

export const feedback: Messages['feedback'] = {
  pageTitle: 'Avalie esta resposta',
  subtitle: 'Sua avaliação nos ajuda a melhorar as respostas que você recebe.',
  ratingFor: 'Você está avaliando',
  answeredAt: (date: string) => `Respondido em ${date}`,
  responseTime: 'Prazo de resposta',
  responseTimeHint: 'A resposta chegou no tempo que você precisava?',
  assertiveness: 'Assertividade',
  assertivenessHint: 'A resposta estava correta e foi útil?',
  scoreLabel: (n: number) => `${n} de 5`,
  scoreLow: 'Ruim',
  scoreHigh: 'Excelente',
  suggestions: 'Sugestões e melhorias',
  suggestionsPlaceholder: 'O que teria deixado esta resposta melhor?',
  charsLeft: (n: number) => `${n} caracteres restantes`,
  submit: 'Enviar avaliação',
  update: 'Atualizar avaliação',
  sending: 'Enviando…',
  nothingToSend: 'Escolha uma nota ou escreva uma sugestão.',
  clearNeedsRating: 'Para remover sua sugestão, mantenha ao menos uma nota.',
  thanksTitle: 'Obrigado!',
  thanksBody: 'Sua avaliação foi registrada. Você pode alterá-la enquanto este link for válido.',
  thanksBodyUntil: (date: string) => `Sua avaliação foi registrada. Você pode alterá-la até ${date}.`,
  edit: 'Alterar minha avaliação',
  previousSubmission: (count: number) =>
    count === 1 ? 'Você já avaliou esta resposta uma vez.' : `Você já avaliou esta resposta ${count} vezes.`,
  invalidTitle: 'Este link não é válido',
  invalidBody: 'O link de avaliação é inválido ou expirou.',
  expiredOn: (date: string) => `Este link de avaliação expirou em ${date}.`,
  inlineClosed: 'Esta resposta não pode mais ser avaliada.',
  inlineClosedOn: (date: string) => `A avaliação desta resposta foi encerrada em ${date}.`
}
